<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('凭证')">{{$t('button.export')}}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-cap-certificate-modal ref="modalForm" @ok="modalFormOk"></efs-cap-certificate-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsCapCertificateModal from './modules/EfsCapCertificateModal'

  export default {
    name: 'EfsCapCertificateList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsCapCertificateModal
    },
    data () {
      return {
        description: '凭证管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'科目代码',
            align:"center",
            dataIndex: 'subjectCode'
          },
          {
            title:'科目编号',
            align:"center",
            dataIndex: 'subjectName'
          },
          {
            title:'成本项编号',
            align:"center",
            dataIndex: 'costCode'
          },
          {
            title:'成本项描述',
            align:"center",
            dataIndex: 'costName'
          },
          {
            title:'凭证类型(10：计提 20：冲销 30：正式 40:结转）',
            align:"center",
            dataIndex: 'certificateType'
          },
          {
            title:'费用类型(10：代养费 20：分红）',
            align:"center",
            dataIndex: 'feeType'
          },
          {
                        slotName: 'tableHeader.company',
            scopedSlots: { title: 'tableHeader.company'},
            align:"center",
            dataIndex: 'companyCode'
          },
          {
            slotName: 'tableHeader.serviceGroup',
            scopedSlots: { title: 'tableHeader.serviceGroup'},
            align:"center",
            dataIndex: 'groupCode'
          },
          {
            title:'养殖场编号',
            align:"center",
            dataIndex: 'farmCode'
          },
          {
            title:'养户编号',
            align:"center",
            dataIndex: 'farmerCode'
          },
          {
            slotName: 'tableHeader.contractNo',
scopedSlots: { title: 'tableHeader.contractNo'},
            align:"center",
            dataIndex: 'conCode'
          },
          {
            slotName: 'tableHeader.batch',
            scopedSlots: { title: 'tableHeader.batch'},
            align:"center",
            dataIndex: 'breedBatchCode'
          },
          {
            title:'推送状态',
            align:"center",
            dataIndex: 'status'
          },
          {
            title:'生成时间',
            align:"center",
            dataIndex: 'certificateTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'记录数量',
            align:"center",
            dataIndex: 'certificateQty'
          },
          {
            slotName: 'tableHeader.amount',
            scopedSlots: { title: 'tableHeader.amount'},
            align:"center",
            dataIndex: 'certificateAmount'
          },
          {
            title:'账期编号',
            align:"center",
            dataIndex: 'accountCode'
          },
          {
            title:'扩展字段',
            align:"center",
            dataIndex: 'buffer1'
          },
          {
            title:'扩展字段',
            align:"center",
            dataIndex: 'buffer2'
          },
          {
            title:'扩展字段',
            align:"center",
            dataIndex: 'buffer3'
          },
          {
            title:'扩展字段',
            align:"center",
            dataIndex: 'buffer4'
          },
          {
            title:'扩展字段',
            align:"center",
            dataIndex: 'buffer5'
          },
          {
            slotName: 'tableHeader.validOrNot',
            scopedSlots: { title: 'tableHeader.validOrNot'},
            align:"center",
            dataIndex: 'validFlag'
          },
          {
            title:'是否删除',
            align:"center",
            dataIndex: 'delFlag'
          },
          {
            slotName: 'tableHeader.remarks',
            scopedSlots: { title: 'tableHeader.remarks'},
            align:"center",
            dataIndex: 'notes'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/certificateManage/efsCapCertificate/list",
          delete: "/certificateManage/efsCapCertificate/delete",
          deleteBatch: "/certificateManage/efsCapCertificate/deleteBatch",
          exportXlsUrl: "/certificateManage/efsCapCertificate/exportXls",
          importExcelUrl: "certificateManage/efsCapCertificate/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>